import './App.css';

import { ParallaxProvider } from 'react-scroll-parallax';
import ReactGA from 'react-ga4';
import { Suspense, lazy, useEffect } from 'react';


import HeroSection from './components/home/herosection';
import Navbar from './components/common/navbar/navbar';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HashScroll from './HashScroll';

// Below-the-fold home content and the secondary routes are code-split so the
// initial bundle only carries the navbar + hero needed for first paint.
const HomeBelowFold = lazy(() => import('./components/home/HomeBelowFold'));
const Photos = lazy(() => import('./photos'));
const NotFound = lazy(() => import('./notfound'));


function App() {
  ReactGA.initialize('G-4JPBBTPW2N');

  // Track initial page view
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  return (
    <Router>
      <HashScroll />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <ParallaxProvider>
                <HeroSection />
                <Suspense fallback={null}>
                  <HomeBelowFold />
                </Suspense>
              </ParallaxProvider>
            </>
          }
        />
        <Route
          path="/photos"
          element={
            <Suspense fallback={null}>
              <Photos />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={null}>
              <NotFound />
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
